<template>
  <div class="_display:flex _align-items:center _width:100% _flex-direction:column _margin-top:5">
    <h2>404 error</h2>
    <p>Page not found</p>
    <i-button
      color="primary"
      class="_margin-top:1"
      @click="$router.push('/')"
    >
      To Home Page
    </i-button>
  </div>
</template>
